// Recordings are sent as 16 kHz mono WAV: every browser can decode what its own MediaRecorder
// produced (WebM/Opus in Chrome, MP4/AAC in Safari), and WAV is accepted everywhere on the
// server side, whatever the device recorded.
const SAMPLE_RATE = 16000;

const encodeWav = samples => {
  const buffer = new ArrayBuffer(44 + samples.length * 2);
  const view = new DataView(buffer);
  const text = (offset, value) =>
    [...value].forEach((char, i) => view.setUint8(offset + i, char.charCodeAt(0)));
  text(0, "RIFF");
  view.setUint32(4, 36 + samples.length * 2, true);
  text(8, "WAVE");
  text(12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, 1, true); // mono
  view.setUint32(24, SAMPLE_RATE, true);
  view.setUint32(28, SAMPLE_RATE * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  text(36, "data");
  view.setUint32(40, samples.length * 2, true);
  samples.forEach((sample, i) => {
    const s = Math.max(-1, Math.min(1, sample));
    view.setInt16(44 + i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true);
  });
  return new Blob([view], { type: "audio/wav" });
};

/** Any recorded blob → 16 kHz mono WAV blob. */
export const toWav = async blob => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  const context = new AudioCtx();
  try {
    const decoded = await new Promise((resolve, reject) => {
      blob
        .arrayBuffer()
        .then(data => {
          // Old Safari only has the callback form.
          const result = context.decodeAudioData(data, resolve, reject);
          if (result?.then) result.then(resolve, reject);
        })
        .catch(reject);
    });
    const length = Math.ceil(decoded.duration * SAMPLE_RATE);
    const Offline = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    const offline = new Offline(1, Math.max(length, 1), SAMPLE_RATE);
    const source = offline.createBufferSource();
    source.buffer = decoded;
    source.connect(offline.destination);
    source.start();
    const rendered = await offline.startRendering();
    return encodeWav(rendered.getChannelData(0));
  } finally {
    context.close?.();
  }
};
